var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser150(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_1636)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 75,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 24,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    y: 100,
    width: 225,
    height: 225,
    rx: 112.5,
    fill: "#E6E6E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_1636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser150);
export default __webpack_public_path__ + "static/media/User-150.d406357feaebe0e1937285ea7a9dbb9b.svg";
export { ForwardRef as ReactComponent };